import type { UiAuthUser } from '../schemas/users.schema';
import type { Maybe } from '../types/maybe.types';

/**
 * A `member` account — onboarding finished, no invitation accepted yet — that
 * belongs on `/pending-invitation` and nowhere else.
 *
 * Only an ACTIVE membership ends the wait: `/auth/me` returns membership rows
 * of every status, so an invitation that has arrived but is not answered yet
 * is already a row. `type` falls back to CLIENT for accounts without a
 * membership, so a member is otherwise only told apart by never having gone
 * through the client wizard that fills in the fitness profile.
 */
export const isPendingMemberInvite = (user: Maybe<UiAuthUser>) =>
  Boolean(
    user?.hasFinishedOnboarding &&
    !user.organizationUsers?.some(
      (membership) => membership.status === 'ACTIVE',
    ) &&
    !user.fitnessProfile,
  );
